import PROD_CONFIG from './config.prod';
import DEV_CONFIG from './config.dev';

export const CONFIG = import.meta.env.PROD ? PROD_CONFIG : DEV_CONFIG;
